import React from 'react';
import { Card } from 'react-bootstrap';

export default function ModelPerformanceDetailedView() {
  return (
    <div className="px-0 pt-2">
      <Card className="p-4 shadow-sm">
        <Card.Body>
          <p className="text-muted mb-0">
            Visão detalhada de desempenho de modelos (placeholder).
          </p>
        </Card.Body>
      </Card>
    </div>
  );
}
